import { Heading, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import FirestoreUser from '../../../types/FirestoreUser'
import ReportingPeriodSelector from './ReportingPeriodSelector'

interface DashboardHeaderProps {
  user: FirestoreUser | undefined
  monthMoment: moment.Moment
  changeToMoment: moment.Moment
  pastDeadline: boolean
  onMonthChange: () => void
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  user,
  monthMoment,
  changeToMoment,
  pastDeadline,
  onMonthChange,
}) => {
  return (
    <Stack spacing={0}>
      <Heading>My Dashboard</Heading>
      <ReportingPeriodSelector
        monthMoment={monthMoment}
        changeToMoment={changeToMoment}
        pastDeadline={pastDeadline}
        onMonthChange={onMonthChange}
      />
      <Text fontSize='sm' as='span' fontWeight='normal'>
        Patient ID: #{user?.patientId}
      </Text>
    </Stack>
  )
}

export default DashboardHeader
